import { ComponentProps } from "react";

const DownloadIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="none" viewBox="0 0 20 21" {...props}>
      <path
        fill="currentColor"
        d="M9.043 16.144a2.5 2.5 0 01-.811-.542l-2.676-2.673a.834.834 0 011.178-1.179l2.425 2.423.008-12.84a.833.833 0 011.667 0l-.006 12.856 2.438-2.439a.834.834 0 011.178 1.176l-2.676 2.676a2.499 2.499 0 01-2.725.542z"
      ></path>
      <path
        fill="currentColor"
        d="M18.577 14.077a.833.833 0 011.423.59V18a2.5 2.5 0 01-2.5 2.5h-15A2.5 2.5 0 010 18v-3.334a.833.833 0 011.667 0V18a.833.833 0 00.833.833h15a.833.833 0 00.833-.833v-3.334c0-.22.088-.432.244-.589z"
      ></path>
    </svg>
  );
};

export default DownloadIcon;
